import {createLogic} from 'redux-logic';
import {
  authResetStorage
} from '../actions';

export const authResetStorageLogic = createLogic({
  type: authResetStorage,
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action}, dispatch, done) {
    action.payload.callback();

    done();
  }
});


// WEBPACK FOOTER //
// ./src/util/redux/auth/logic/reset.js